import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { MatDialog } from "@angular/material/dialog";
import { Location, isPlatformBrowser } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';
import { ElementRef, Inject, PLATFORM_ID } from "@angular/core";
import { SecurityProvider } from "../providers/security.provider";
import { ApiService } from "./api.service";
import { SharedFunctions } from "./shared_functions";
import { environment } from "../../environments/environment";
import { ShowBasicAlert } from "./global_functions";

export class MainContentClass {

  messageNoInternet = "No se tiene conexión a internet, por favor verifique e intente nuevamente";
  messageNoData = "No se encontraron resultados";
  messageError = "Ocurrió un error";
  messageSessionExpired = "Tu sesión ha caducado, por tu seguridad hemos cerrado el acceso";
  messageErrorSession = "Tu sesión ha caducado, por tu seguridad hemos cerrado el acceso";
  messageErrorData = "Ocurrió un error";
  messageErrorServer = "Ocurrió un error en el servidor";
  messageErrorRequired = "Campo obligatorio";
  messageErrorDateInvalid = 'La fecha de fin no puede ser menor que la fecha de inicio.';
  messageErrorDateInvalidStart = 'La fecha de inicio no puede mayor que la fecha fin.';
  messageErrorInvalid = "Formato inválido";
  grilaftCode = 4713;

  loadingScreen: boolean = false;
  helper: SharedFunctions = new SharedFunctions();
  public broadcast = new BroadcastChannel('session_channel');

  constructor(
    protected router: Router, 
    protected route: ActivatedRoute, 
    protected genericService: ApiService, 
    dialog: MatDialog,
    @Inject(PLATFORM_ID) protected platformId: Object,
    ) {
    
    // var userExist = SecurityProvider.getUserDecoded();
    // if(userExist == ""){
    //   this.router.navigate(['auth/login']);
    //   return;
    // }
  }


  fieldValidated(form: FormGroup, field: string) {
    return this.helper.fieldValidated(form, field);
  }

  logout() {
    this.router.navigate(['admin/ofpagesession']);
  }

  convertToUpperCase(event: any): void {
    let input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }

  parseDate(dateText: string ): string {
    if(dateText == "") return "";
    var split = dateText.split('/');
    return split[2]+"-"+split[1]+"-"+split[0];
  }

  parseDateToView(dateText: string ): string {
    if(dateText == "" || dateText == null) return "";
    var split = dateText.split('-');
    return split[2]+"/"+split[1]+"/"+split[0];
  }

  public getPhraseHash = (): string => {
    return environment.secretKeyApp + environment.secretKey;
  }

  public hashPrasse = (phrase: string): string => {
    return SecurityProvider.encryptByUrl(phrase, this.getPhraseHash());
  }

  alphanumericFilter(event: any, form: any, fieldName:string ): void {
    const input = event.target.value;
    const filteredInput = input.replace(/[^a-zA-Z0-9]/g, '');
    form.get(fieldName)?.setValue(filteredInput, { emitEvent: false });
  }

  getParamUrl = (): string[] => {
    var id = this.route.snapshot.paramMap.get('id') || "0";
    if (id != null && id != "") {
      if (id != "0") {
        let documentData = SecurityProvider.decryptByUrl(id, this.getPhraseHash()).split("-");
        if (documentData.length > 0) {
          if (+documentData[1] > 0) {
            return documentData;
          }
          return documentData;
        }
      }
    }
    return [];
  }

  
  showConfirmationMessage(message: string, okButtonText: string = 'Aceptar', cancelButton: string = 'Cancelar', okPressed: Function, cancelPressed?: Function) {
    if (message) {
      Swal.fire({
        text: message,
        confirmButtonColor: '#552DE4',
        allowEscapeKey: false,
        confirmButtonText: okButtonText,
        cancelButtonText: cancelButton,
        cancelButtonColor: '#49C353',
        showCancelButton: true,
        showConfirmButton: true,
        allowOutsideClick: false,
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `
        }
      }).then((result) => {
        if (result.isConfirmed) {
          okPressed();
        } 
        else if (result.isDismissed) {
          if(cancelPressed != undefined) {
            cancelPressed();
          }
        }
      });
    }

  }

  showInfoMessage(message: string, btnTextMessage: string = 'Aceptar', callback: Function) {
    if(message) {
      Swal.fire({
        text: message,
        confirmButtonColor: '#552DE4',
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: btnTextMessage,
        showConfirmButton: true,
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `
        }
      }).then((result) => {
        if(result.isConfirmed) {
          callback();
        }
      });
    }
  }

  validationStatusResponse(response: any, callback: Function) {
    if(response.message !="" && response.message !=null) {
        if (response.status == 401 || response.status == 400) {
          ShowBasicAlert({
            text: response.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#552DE4',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
          });
        } else if (response.status == 406) {
  
          ShowBasicAlert({
            text: response.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#552DE4',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if(result.isConfirmed) {
              callback();
            }
          });
        } else {
          ShowBasicAlert({
            text: response.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#552DE4',
            allowOutsideClick: false,
            allowEscapeKey: response.status == 200 ? false : true
          }).then((result) => {
            if (result.isConfirmed) {
              if (response.status == 200) {
                callback();
              }
            }
          });
        }
      } else {
        callback();
      }
  }


  public showLoader = () => {
    if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          const spinnerElement = document.querySelector('#spinner');
          if (spinnerElement) {
            spinnerElement.classList.add('show');
          }
        }, 1);
      }
  }

  public showToast(msg = '', color:any ="primary", position: any = 'bottom-start', showCloseButton = true, closeButtonHtml = '', duration = 3000) {
    const toast = Swal.mixin({
      toast: true,
      position: position || 'bottom-start',
      showConfirmButton: false,
      timer: duration,
      showCloseButton: showCloseButton,
      customClass: {
          popup: `color-${color}`
      },
      target: document.getElementById(color + '-toast')
    });
    toast.fire({
        title: msg,
    });
  }

  public hideLoader = () => {
    if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          const spinnerElement = document.querySelector('#spinner');
          if (spinnerElement) {
            spinnerElement.classList.remove('show');
          }
        }, 1);
      }
  }


  validationErrorIfWindowNotReload(err: any) {
    if (err.status == 401) {
      var hasReloaded = localStorage.getItem("hasWarning") ?? "0";
      if(hasReloaded == "1") {
        //this.logout();
        this.broadcast.postMessage({ type: 'SESSION_EXPIRED' });
        return;
      } else {
        localStorage.setItem("hasWarning", "1");
        this.broadcast.postMessage({ type: 'SESSION_FAIL' });
      }
      
    } else {
      if (err.error.message) {
        ShowBasicAlert({
          text: err.error.message,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#552DE4',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      }
    }
  }

  goToBack(urlSaved: string, keySave:string, urlBack:string) {
    if(urlSaved != "") {
      localStorage.setItem(keySave, urlSaved);
    }
    this.router.navigate([urlBack]);
  }
  
  goToView(urlSaved: string) {
    this.router.navigate([urlSaved]);
  }

  public formatCurrencyInput(event: any): void {
    let input = event.target as HTMLInputElement;
    let rawValue = input.value.replace(/[^0-9]/g, '');
    if (rawValue) {
      input.value = this.formatCurrency(+rawValue / 100);
      input.setSelectionRange(input.value.length, input.value.length);
    } else {
      input.value = '';
    }
  }


  public formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-PE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }


  public getMoneyFormated(value:string) :string {
    if (value != "") {
      return this.formatCurrency(+value / 100);
    } else {
      return '';
    }
  }

  public safeString(input: any, maxLength?: number): string {
    let safeStr = input ? String(input).trim() : '';
    if (maxLength && safeStr.length > maxLength) {
      safeStr = safeStr.substring(0, maxLength);
    }

    return safeStr;
  }

  dateToText(valueInfo: string):string {
    return SharedFunctions.formatDateToText(valueInfo);
  }

  getIdCustomer(): Promise<string> {
    return new Promise((resolve) => {
      const value = localStorage.getItem(environment.constants.uid);
      if(value == null) {
        resolve("");
      } else {
        var phrasse = this.getPhraseHash();
        var d = SecurityProvider.decryptByUrl(value, phrasse);
        resolve(d);
      }
    });
  }


  async hasConectionEthernet(): Promise<boolean> {
    try {
        // const response = await fetch("https://www.google.com", { method: "HEAD", mode: "no-cors" });
        // return response.ok;
        return navigator.onLine;
    } catch (error) {
        return false;
    }
  }

  downloadPdf(base64Pdf: string, fileName: string) {
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  decodeBase64Excel(base64: string, fileName: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }


  getOrCreateBrowserId(username: string): string {
    const cookieName = 'browser_id';
    const storedUsername = this.getCookie('current_user');
    if (!storedUsername || storedUsername !== username) {
      const newBrowserId = uuidv4();
      document.cookie = `${cookieName}=${newBrowserId}; path=/; max-age=${60 * 60 * 24 * 365}; Secure`;
      document.cookie = `current_user=${username}; path=/; max-age=${60 * 60 * 24 * 365}; Secure`;
  
      return newBrowserId;
    }

    return this.getCookie(cookieName) || uuidv4();
  }
  

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
  }

  getPhrasseTohash(): string {
    return SecurityProvider.getUserDecoded()+ '0p3RA.Us4r';
  }

  validatorDateOnTyped(event:any) : string {
    if (!event || !event.target) { return ""; }
  
    const inputValue = event.target.value;
  
    if (!inputValue) { return ""; }
    const rawValue = inputValue.replace(/\D/g, '');
    
    let formatted = '';
    if (rawValue.length > 0) formatted += rawValue.substring(0, 2);
    if (rawValue.length > 2) formatted += '/' + rawValue.substring(2, 4);
    if (rawValue.length > 4) formatted += '/' + rawValue.substring(4, 8);
  
    return formatted;
  }

  checkFormatUpdateCalendar(formattedValue: string, calendarOnTyped: ElementRef, callback: Function){
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedValue)) {
      callback();
  
      setTimeout(() => {
        if (calendarOnTyped && calendarOnTyped.nativeElement) {
          calendarOnTyped.nativeElement._flatpickr.setDate(formattedValue, false);
        }
      }, 100);
    }
  }
  
  checkDateDiff(fechaInicio: string,fechaFin: string ) :boolean {
    if (!fechaInicio || !fechaFin) {
      return false;
    }
    const startDate = this.parseDateToReal(fechaInicio);
    const endDate = this.parseDateToReal(fechaFin);

    if (endDate < startDate) {
      return false;
    } else {
      return true;
    }
  }
  
  parseDateToReal(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }


  getFormattedDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
  
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    const second = now.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
  

  copyText(text: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Método moderno (soportado en la mayoría de los navegadores)
      navigator.clipboard.writeText(text).then(() => {
        this.showToast('Texto copiado al portapapeles', "success");
      }).catch(err => {
        this.showToast('Texto copiado al portapapeles', "error");
      });
    } else {
      // Método de compatibilidad para navegadores antiguos
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      textArea.setSelectionRange(0, 99999); // Para móviles
      document.execCommand('copy');
      document.body.removeChild(textArea); // Limpia el DOM
      this.showToast('Texto copiado al portapapeles', "success");
    }
  }
  
  

}
